import React, { Component } from 'react';
import './UmpireCompletedGamesTable.css';
import PropTypes from 'prop-types';
import { withStyles, Grid, Typography, Tooltip } from '@material-ui/core';

import { getEliteStatus, renderWheelInfo, renderTeams } from './statistics/gameStatistics';
import GameCard from './cards/GameCard';

const styles = {
  box: {
    padding: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#eeeeee'
  },
  gamesHeader: {
    display: 'flex',
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 86,
    padding: 8,
    fontSize: 18
  },
  icon: {
    marginLeft: 6,
    height: 24,
  }
};

class UmpireCompletedGamesTable extends Component {

  componentDidMount() {
    const { userSeason, memberId, getSeasonDivisions, getSeasonUmpireData, 
            getMyGames, getUmpireStats, getTeamsVolunteering } = this.props;

    if (userSeason) {
      getSeasonDivisions(userSeason);
      getSeasonUmpireData(userSeason);
      getMyGames(userSeason, null, memberId, null);
      getUmpireStats(userSeason, memberId);
      getTeamsVolunteering(memberId, userSeason);
    }
  };

  componentDidUpdate(prevProps) {
    const { userSeason, memberId, getSeasonDivisions, getSeasonUmpireData, 
            getMyGames, getUmpireStats, getTeamsVolunteering } = this.props;
    //Retrieve Games. Umpires and Divisions on change of Season
    if (userSeason !== prevProps.userSeason) {
      getSeasonDivisions(userSeason);
      getSeasonUmpireData(userSeason);
      getMyGames(userSeason, null, memberId, null);
      getUmpireStats(userSeason, memberId);
      getTeamsVolunteering(memberId, userSeason);
    }
  };

  allLoaded = () => {
    //Check that all required state objects have been loaded
    const { fetchingMyGamesStatus, fetchingSeasonUmpireDataStatus, 
            fetchingSeasonDivisionsStatus, fetchingUmpireStatsStatus, teamsVolunteeringStatus } = this.props;
    return  fetchingMyGamesStatus === 'Loaded' &&
            fetchingSeasonUmpireDataStatus === 'Loaded' &&
            fetchingSeasonDivisionsStatus === 'Loaded' &&
            fetchingUmpireStatsStatus === 'Loaded' &&
            teamsVolunteeringStatus === 'Loaded';
  };

  render() {
    const {
      games, myGamesList, seasonDivisions,
      seasonUmpires, seasonUmpiresList, fetchingSeasonUmpireDataStatus,
      memberId, umpireLevel, umpireStats, teamsVolunteering
    } = this.props;
    const { classes } = this.props;
    let outputList = [];
    let gameTotal = 0;
    let eliteStatus = {};

    if (this.allLoaded()) {
      outputList = myGamesList;
      gameTotal = umpireStats.plateTotal + umpireStats.baseTotal;
      eliteStatus = getEliteStatus(gameTotal);
    }

    return (
      <div className="games-list-container report-list-container-main">
        <div className={classes.gamesHeader}>
          {this.allLoaded() ?
            <Grid container spacing={8}>
                <Grid item xs={2}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      Level
                    </Typography>
                    <Typography align="center" variant="h4" component="h2">
                      {umpireLevel}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      Teams Rep.
                    </Typography>
                    {renderTeams(teamsVolunteering)}
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      Wheel
                    </Typography>
                    {renderWheelInfo(umpireStats)}
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      Completed
                    </Typography>
                    <Typography align="center" variant="h4" component="h2">
                      {gameTotal}
                      {eliteStatus.icon && <Tooltip title={eliteStatus.title}><img src={eliteStatus.icon} alt={eliteStatus.title} className={classes.icon}/></Tooltip>}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      @ Plate
                    </Typography>
                    <Typography align="center" variant="h4" component="h2">
                      {umpireStats.plateTotal}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div className={classes.box}>
                    <Typography align="center" color="textSecondary">
                      @ Base
                    </Typography>
                    <Typography align="center" variant="h4" component="h2">
                      {umpireStats.baseTotal}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            :
            <Typography align="center" color="textSecondary">
              Loading Statistics...
            </Typography>
          }
        </div>
        <table className="games-list List-Table">
          <thead>
            <tr>
              <th>Game Information</th>
              <th>Umpires</th>
            </tr>
          </thead>
          <tbody>
            {this.allLoaded() ?
              outputList.length > 0 ? (
                outputList.map((id, index) => {
                  return (
                    <tr className="row-highlighter" key={games[id].id}>
                      <td>
                        <GameCard
                          games={games}
                          gameId={id}
                          umpires={seasonUmpires}
                          umpiresList={seasonUmpiresList}
                          fetchingUmpiresStatus={fetchingSeasonUmpireDataStatus}
                          memberId={memberId}
                          assignUmpToGame={this.props.assignUmpToGame}
                          removeUmp={this.props.removeUmp}
                          allowsAssigning={false}
                          seasonDivisions={seasonDivisions}
                          isRow={true}
                        />
                      </td>
                    </tr>
                  );
                })
                ): (
                  <tr className="row-highlighter">
                    <td>No games for the selected season.</td>
                  </tr>
                )
            :
            <tr className="row-highlighter">
              <td>Loading Games...</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    );
  }
}

UmpireCompletedGamesTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UmpireCompletedGamesTable);



// WEBPACK FOOTER //
// ./src/components/UmpireCompletedGamesTableV2.js